
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface DurationOption {
  id: string;
  label: string;
  hours: number;
  display_order: number;
  is_active: boolean;
}

export const useDurationOptions = () => {
  const [durationOptions, setDurationOptions] = useState<DurationOption[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDurationOptions = async () => {
      try {
        setIsLoading(true);
        const { data, error } = await supabase
          .from('duration_options')
          .select('*')
          .eq('is_active', true)
          .order('display_order');

        if (error) {
          console.error('Erreur lors du chargement des options de durée:', error);
          setError(error.message);
          return;
        }

        setDurationOptions(data || []);
      } catch (err) {
        console.error('Erreur:', err);
        setError('Erreur lors du chargement des options de durée');
      } finally {
        setIsLoading(false);
      }
    };

    fetchDurationOptions();
  }, []);

  const getDurationByLabel = (label: string): DurationOption | undefined => {
    return durationOptions.find(option => option.label === label);
  };

  const getDurationByHours = (hours: number): DurationOption | undefined => {
    return durationOptions.find(option => option.hours === hours);
  };

  const getHoursFromLabel = (label: string): number => {
    const option = getDurationByLabel(label);
    return option ? option.hours : 0; // Aucune durée par défaut
  };

  return {
    durationOptions,
    isLoading,
    error,
    getDurationByLabel,
    getDurationByHours,
    getHoursFromLabel
  };
};
